export default __webpack_public_path__ + "static/media/tylerh.e6b72cc5.gif";